"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OldOfferSubType = exports.OfferSubType = exports.OfferType = void 0;
var OfferType;
(function (OfferType) {
    OfferType["PRODUCT"] = "PRODUCT";
    OfferType["SERVICE_LINE"] = "SERVICE_LINE";
    OfferType["EXPERIENCE"] = "EXPERIENCE";
})(OfferType = exports.OfferType || (exports.OfferType = {}));
var OfferSubType;
(function (OfferSubType) {
    OfferSubType["UNKNOWN"] = "UNKNOWN";
    // Services
    OfferSubType["HEALTH"] = "HEALTH";
    OfferSubType["VETERINARIAN"] = "VETERINARIAN";
    OfferSubType["VACCINATIONS"] = "VACCINATIONS";
    OfferSubType["GENERAL_CHECKUP"] = "GENERAL_CHECKUP";
    OfferSubType["EMERGENCY_CARE"] = "EMERGENCY_CARE";
    OfferSubType["SURGICAL_CARE"] = "SURGICAL_CARE";
    OfferSubType["NUTRITION"] = "NUTRITION";
    OfferSubType["PHARMACY_SERVICES"] = "PHARMACY_SERVICES";
    OfferSubType["SPECIALIST_CARE"] = "SPECIALIST_CARE";
    OfferSubType["SPECIALIST_SKIN_CARE"] = "SPECIALIST_SKIN_CARE";
    OfferSubType["SPECIALIST_HAIR_CARE"] = "SPECIALIST_HAIR_CARE";
    OfferSubType["SPECIALIST_EYE_CARE"] = "SPECIALIST_EYE_CARE";
    OfferSubType["SPECIALIST_DIGESTIVE_CARE"] = "SPECIALIST_DIGESTIVE_CARE";
    OfferSubType["SPECIALIST_DENTAL_CARE"] = "SPECIALIST_DENTAL_CARE";
    OfferSubType["TRAINING_SERVICES"] = "TRAINING_SERVICES";
    OfferSubType["BEHAVIORAL_TRAINING"] = "BEHAVIORAL_TRAINING";
    OfferSubType["PUPPY_TRAINING"] = "PUPPY_TRAINING";
    OfferSubType["OBEDIENCE_I_TRAINING"] = "OBEDIENCE_I_TRAINING";
    OfferSubType["FOUNDATION_SKILLS_TRAINING"] = "FOUNDATION_SKILLS_TRAINING";
    OfferSubType["SKILL_BUILDING_TRAINING"] = "SKILL_BUILDING_TRAINING";
    OfferSubType["RELIABILITY_TRAINING"] = "RELIABILITY_TRAINING";
    OfferSubType["ADVANCED_SKILLS_TRAINING"] = "ADVANCED_SKILLS_TRAINING";
    OfferSubType["EXPERT_SKILLS_TRAINING"] = "EXPERT_SKILLS_TRAINING";
    OfferSubType["SPORT_TRAINING_SERVICES"] = "SPORT_TRAINING_SERVICES";
    OfferSubType["AGILITY_TRAINING_SERVICES"] = "AGILITY_TRAINING_SERVICES";
    OfferSubType["HUNTING_TRAINING"] = "HUNTING_TRAINING";
    OfferSubType["GUARD_TRAINING"] = "GUARD_TRAINING";
    OfferSubType["GROOMING_SERVICES"] = "GROOMING_SERVICES";
    OfferSubType["HAIR_GROOMING"] = "HAIR_GROOMING";
    OfferSubType["NAIL_GROOMING"] = "NAIL_GROOMING";
    OfferSubType["EAR_SPECIALIST"] = "EAR_SPECIALIST";
    OfferSubType["SKIN_SPECIALIST"] = "SKIN_SPECIALIST";
    OfferSubType["SOCIAL"] = "SOCIAL";
    OfferSubType["SOCIAL_SUPPORT"] = "SOCIAL_SUPPORT";
    OfferSubType["DOG_WALKERS"] = "DOG_WALKERS";
    OfferSubType["DAYCARE"] = "DAYCARE";
    OfferSubType["DOG_SITTER"] = "DOG_SITTER";
    OfferSubType["BOARDING"] = "BOARDING";
    OfferSubType["DROP_IN_VISITS"] = "DROP_IN_VISITS";
    OfferSubType["ADOPTION_SERVICES"] = "ADOPTION_SERVICES";
    OfferSubType["SOCIAL_RECREATIONAL"] = "SOCIAL_RECREATIONAL";
    OfferSubType["DOG_MEET_UP"] = "DOG_MEET_UP";
    OfferSubType["DOG_PLAY_GROUPS"] = "DOG_PLAY_GROUPS";
    OfferSubType["ADULT_PLAY_GROUPS"] = "ADULT_PLAY_GROUPS";
    OfferSubType["PUPPY_PLAY_GROUPS"] = "PUPPY_PLAY_GROUPS";
    OfferSubType["RECREATIONAL_DOG_PARKS"] = "RECREATIONAL_DOG_PARKS";
    OfferSubType["SMALL_DOG_PARKS"] = "SMALL_DOG_PARKS";
    OfferSubType["DOG_PARKS"] = "DOG_PARKS";
    OfferSubType["PUPPY_PARKS"] = "PUPPY_PARKS";
    // Products
    OfferSubType["EDIBLES"] = "EDIBLES";
    OfferSubType["FOODS"] = "FOODS";
    OfferSubType["MEALS"] = "MEALS";
    OfferSubType["WET_FOODS"] = "WET_FOODS";
    OfferSubType["DRY_FOODS"] = "DRY_FOODS";
    OfferSubType["RAW_FOODS"] = "RAW_FOODS";
    OfferSubType["FROZEN_FOODS"] = "FROZEN_FOODS";
    OfferSubType["FREEZE_DRIED_FOODS"] = "FREEZE_DRIED_FOODS";
    OfferSubType["TREATS"] = "TREATS";
    OfferSubType["HARD_TREATS"] = "HARD_TREATS";
    OfferSubType["BISCUITS"] = "BISCUITS";
    OfferSubType["BONES_RAWHIDE"] = "BONES_RAWHIDE";
    OfferSubType["SOFT_TREATS"] = "SOFT_TREATS";
    OfferSubType["CHEWY_TREATS"] = "CHEWY_TREATS";
    OfferSubType["JERKY_TREATS"] = "JERKY_TREATS";
    OfferSubType["DEHYDRATED_TREATS"] = "DEHYDRATED_TREATS";
    OfferSubType["PILL_COVERS"] = "PILL_COVERS";
    OfferSubType["SUPPLEMENTS"] = "SUPPLEMENTS";
    OfferSubType["TOPPINGS"] = "TOPPINGS";
    OfferSubType["VITAMINS"] = "VITAMINS";
    OfferSubType["DIGESTIBLE_MEDICINES"] = "DIGESTIBLE_MEDICINES";
    OfferSubType["DIGESTIBLE_DENTAL_CARE"] = "DIGESTIBLE_DENTAL_CARE";
    OfferSubType["DIGESTIBLE_PEST_CONTROL"] = "DIGESTIBLE_PEST_CONTROL";
    OfferSubType["DIGESTIBLE_FLEA_TICK_MEDICINE"] = "DIGESTIBLE_FLEA_TICK_MEDICINE";
    OfferSubType["DIGESTIBLE_DISEASE_PREVENTION"] = "DIGESTIBLE_DISEASE_PREVENTION";
    OfferSubType["GASTRO_MEDICINES"] = "GASTRO_MEDICINES";
    OfferSubType["DIGESTIBLE_URINARY_MEDICINES"] = "DIGESTIBLE_URINARY_MEDICINES";
    OfferSubType["DIGESTIBLE_LIVER_MEDICINES"] = "DIGESTIBLE_LIVER_MEDICINES";
    OfferSubType["DIGESTIBLE_HEART_MEDICINES"] = "DIGESTIBLE_HEART_MEDICINES";
    OfferSubType["DIGESTIBLE_DISEASE_MANAGEMENT"] = "DIGESTIBLE_DISEASE_MANAGEMENT";
    OfferSubType["CARE"] = "CARE";
    OfferSubType["EAR_CARE"] = "EAR_CARE";
    OfferSubType["EAR_CARE_WIPES"] = "EAR_CARE_WIPES";
    OfferSubType["EAR_CARE_LIQUIDS"] = "EAR_CARE_LIQUIDS";
    OfferSubType["EAR_CARE_GELS"] = "EAR_CARE_GELS";
    OfferSubType["EAR_CARE_POWDERS"] = "EAR_CARE_POWDERS";
    OfferSubType["EYE_CARE"] = "EYE_CARE";
    OfferSubType["EYE_CARE_WIPES"] = "EYE_CARE_WIPES";
    OfferSubType["EYE_CARE_LIQUIDS"] = "EYE_CARE_LIQUIDS";
    OfferSubType["EYE_CARE_GELS"] = "EYE_CARE_GELS";
    OfferSubType["EYE_CARE_POWDERS"] = "EYE_CARE_POWDERS";
    OfferSubType["COAT_SKIN_CARE"] = "COAT_SKIN_CARE";
    OfferSubType["COAT_SKIN_CLEANING"] = "COAT_SKIN_CLEANING";
    OfferSubType["CLIPPER_BLADES"] = "CLIPPER_BLADES";
    OfferSubType["CLIPPER_BLADES_PARTS"] = "CLIPPER_BLADES_PARTS";
    OfferSubType["HAIR_CLIPPER_SHEARS"] = "HAIR_CLIPPER_SHEARS";
    OfferSubType["SHAMPOOS"] = "SHAMPOOS";
    OfferSubType["FLEA_TICK_SHAMPOOS"] = "FLEA_TICK_SHAMPOOS";
    OfferSubType["CONDITIONERS"] = "CONDITIONERS";
    OfferSubType["DETANGLERS"] = "DETANGLERS";
    OfferSubType["DRYERS"] = "DRYERS";
    OfferSubType["COMBS_BRUSHES"] = "COMBS_BRUSHES";
    OfferSubType["SPECIALTY_COMBS_BRUSHES"] = "SPECIALTY_COMBS_BRUSHES";
    OfferSubType["FLEA_COMBS"] = "FLEA_COMBS";
    OfferSubType["SKIN_WIPES"] = "SKIN_WIPES";
    OfferSubType["FLEA_TICK_WIPES"] = "FLEA_TICK_WIPES";
    OfferSubType["COAT_SKIN_MAINTENANCE"] = "COAT_SKIN_MAINTENANCE";
    OfferSubType["COAT_SKIN_SPRAYS"] = "COAT_SKIN_SPRAYS";
    OfferSubType["COLOGNES"] = "COLOGNES";
    OfferSubType["COAT_SKIN_DEODORIZERS"] = "COAT_SKIN_DEODORIZERS";
    OfferSubType["TOPICALS"] = "TOPICALS";
    OfferSubType["ITCH_RELIEFS"] = "ITCH_RELIEFS";
    OfferSubType["SUN_SCREENS"] = "SUN_SCREENS";
    OfferSubType["CREAMS_MOISTURIZERS"] = "CREAMS_MOISTURIZERS";
    OfferSubType["SKIN_APPLICATIONS"] = "SKIN_APPLICATIONS";
    OfferSubType["HIP_JOINT_APPLICATIONS"] = "HIP_JOINT_APPLICATIONS";
    OfferSubType["INTERNAL_RELIEF_APPLICATIONS"] = "INTERNAL_RELIEF_APPLICATIONS";
    OfferSubType["MOUTH_CARE"] = "MOUTH_CARE";
    OfferSubType["TOOTH_BRUSHES"] = "TOOTH_BRUSHES";
    OfferSubType["TOOTH_PASTES"] = "TOOTH_PASTES";
    OfferSubType["DENTAL_GELS"] = "DENTAL_GELS";
    OfferSubType["DENTAL_FOAMS"] = "DENTAL_FOAMS";
    OfferSubType["DENTAL_WIPES"] = "DENTAL_WIPES";
    OfferSubType["DENTAL_SPRAYS"] = "DENTAL_SPRAYS";
    OfferSubType["PAW_CARE"] = "PAW_CARE";
    OfferSubType["PAW_CREAMS_MOISTURIZERS"] = "PAW_CREAMS_MOISTURIZERS";
    OfferSubType["NAIL_CLIPPERS"] = "NAIL_CLIPPERS";
    OfferSubType["NAIL_CLIPPER_ACCESSORIES"] = "NAIL_CLIPPER_ACCESSORIES";
    OfferSubType["NAIL_CLIPPER_BLADE_PARTS"] = "NAIL_CLIPPER_BLADE_PARTS";
    OfferSubType["NAIL_POLISHERS"] = "NAIL_POLISHERS";
    OfferSubType["NAIL_GRINDERS"] = "NAIL_GRINDERS";
    OfferSubType["NAIL_GRINDER_ACCESSORIES"] = "NAIL_GRINDER_ACCESSORIES";
    OfferSubType["CALMING_CARE"] = "CALMING_CARE";
    OfferSubType["CALMING_SPRAYS"] = "CALMING_SPRAYS";
    OfferSubType["FEEDING"] = "FEEDING";
    OfferSubType["FEEDERS"] = "FEEDERS";
    OfferSubType["AUTOMATED_FEEDERS"] = "AUTOMATED_FEEDERS";
    OfferSubType["AUTOMATED_WATER_FOUNTAINS"] = "AUTOMATED_WATER_FOUNTAINS";
    OfferSubType["MECHANICAL_FEEDERS"] = "MECHANICAL_FEEDERS";
    OfferSubType["MECHANICAL_WATER_FOUNTAINS"] = "MECHANICAL_WATER_FOUNTAINS";
    OfferSubType["FEEDING_ACCESSORIES"] = "FEEDING_ACCESSORIES";
    OfferSubType["FOUNTAIN_ACCESSORIES"] = "FOUNTAIN_ACCESSORIES";
    OfferSubType["FILTERS_PUMPS"] = "FILTERS_PUMPS";
    OfferSubType["SLOW_FEEDERS"] = "SLOW_FEEDERS";
    OfferSubType["LICK_PADS"] = "LICK_PADS";
    OfferSubType["FEEDING_PUZZLES"] = "FEEDING_PUZZLES";
    OfferSubType["DISHES"] = "DISHES";
    OfferSubType["IN_HOME_DISHES"] = "IN_HOME_DISHES";
    OfferSubType["BOWLS"] = "BOWLS";
    OfferSubType["ELEVATED_BOWLS"] = "ELEVATED_BOWLS";
    OfferSubType["DOUBLE_BOWLS"] = "DOUBLE_BOWLS";
    OfferSubType["CRATE_BOWLS"] = "CRATE_BOWLS";
    OfferSubType["OUT_DOOR_DISHES"] = "OUT_DOOR_DISHES";
    OfferSubType["TRAVEL_BOWLS"] = "TRAVEL_BOWLS";
    OfferSubType["BOTTLES"] = "BOTTLES";
    OfferSubType["KENNEL_BOWLS"] = "KENNEL_BOWLS";
    OfferSubType["FOOD_STORAGE"] = "FOOD_STORAGE";
    OfferSubType["IN_HOME_FOOD_STORAGE"] = "IN_HOME_FOOD_STORAGE";
    OfferSubType["FOOD_BINS"] = "FOOD_BINS";
    OfferSubType["CAN_COVERS"] = "CAN_COVERS";
    OfferSubType["TREAT_JARS"] = "TREAT_JARS";
    OfferSubType["TRAVEL_FOOD_STORAGE"] = "TRAVEL_FOOD_STORAGE";
    OfferSubType["TREAT_POUCHES"] = "TREAT_POUCHES";
    OfferSubType["PLACEMATS"] = "PLACEMATS";
    OfferSubType["STANDS"] = "STANDS";
    OfferSubType["WEARABLES"] = "WEARABLES";
    OfferSubType["NECK_WEARABLES"] = "NECK_WEARABLES";
    OfferSubType["LEASHES"] = "LEASHES";
    OfferSubType["TRAINING_LEASHES"] = "TRAINING_LEASHES";
    OfferSubType["SLIP_LEASHES"] = "SLIP_LEASHES";
    OfferSubType["MARTINGALE_LEADS"] = "MARTINGALE_LEADS";
    OfferSubType["SPECIALTY_LEASHES"] = "SPECIALTY_LEASHES";
    OfferSubType["MULTI_LEASHES"] = "MULTI_LEASHES";
    OfferSubType["SEAT_BELT_LEASHES"] = "SEAT_BELT_LEASHES";
    OfferSubType["BIKE_LEASHES"] = "BIKE_LEASHES";
    OfferSubType["HANDS_FREE_LEASHES"] = "HANDS_FREE_LEASHES";
    OfferSubType["STANDARD_LEASHES"] = "STANDARD_LEASHES";
    OfferSubType["RETRACTABLE_LEASHES"] = "RETRACTABLE_LEASHES";
    OfferSubType["ADJUSTABLE_LEASHES"] = "ADJUSTABLE_LEASHES";
    OfferSubType["CHAIN_LEASHES"] = "CHAIN_LEASHES";
    OfferSubType["COLLARS"] = "COLLARS";
    OfferSubType["TRAINING_COLLARS"] = "TRAINING_COLLARS";
    OfferSubType["SHOCK_COLLARS"] = "SHOCK_COLLARS";
    OfferSubType["SLIP_COLLARS"] = "SLIP_COLLARS";
    OfferSubType["CHOKE_COLLARS"] = "CHOKE_COLLARS";
    OfferSubType["PRONG_PINCH_COLLARS"] = "PRONG_PINCH_COLLARS";
    OfferSubType["MARTINGALE_COLLARS"] = "MARTINGALE_COLLARS";
    OfferSubType["SPECIALTY_COLLARS"] = "SPECIALTY_COLLARS";
    OfferSubType["FLEA_TICK_COLLARS"] = "FLEA_TICK_COLLARS";
    OfferSubType["BARK_CONTROL_COLLARS"] = "BARK_CONTROL_COLLARS";
    OfferSubType["SPRAY_COLLARS"] = "SPRAY_COLLARS";
    OfferSubType["ULTRASONIC_COLLARS"] = "ULTRASONIC_COLLARS";
    OfferSubType["VIBRATING_COLLARS"] = "VIBRATING_COLLARS";
    OfferSubType["ELIZABETHAN_COLLARS"] = "ELIZABETHAN_COLLARS";
    OfferSubType["GPS_COLLARS"] = "GPS_COLLARS";
    OfferSubType["FLAT_COLLARS"] = "FLAT_COLLARS";
    OfferSubType["BUCKLE_COLLARS"] = "BUCKLE_COLLARS";
    OfferSubType["SNAP_COLLARS"] = "SNAP_COLLARS";
    OfferSubType["TIES"] = "TIES";
    OfferSubType["SCARVES"] = "SCARVES";
    OfferSubType["HEAD_WEARABLES"] = "HEAD_WEARABLES";
    OfferSubType["HEAD_COLLARS"] = "HEAD_COLLARS";
    OfferSubType["HATS"] = "HATS";
    OfferSubType["MUZZLES"] = "MUZZLES";
    OfferSubType["FEET_WEARABLES"] = "FEET_WEARABLES";
    OfferSubType["SOCKS"] = "SOCKS";
    OfferSubType["BOOTS"] = "BOOTS";
    OfferSubType["FULL_BODY_WEARABLES"] = "FULL_BODY_WEARABLES";
    OfferSubType["BLANKETS"] = "BLANKETS";
    OfferSubType["PAJAMAS"] = "PAJAMAS";
    OfferSubType["TOWELS"] = "TOWELS";
    OfferSubType["CHEST_WEARABLES"] = "CHEST_WEARABLES";
    OfferSubType["JACKETS"] = "JACKETS";
    OfferSubType["SHIRTS"] = "SHIRTS";
    OfferSubType["COSTUMES"] = "COSTUMES";
    OfferSubType["DRESSES"] = "DRESSES";
    OfferSubType["HARNESSES"] = "HARNESSES";
    OfferSubType["FRONT_CLIP_HARNESSES"] = "FRONT_CLIP_HARNESSES";
    OfferSubType["BACK_CLIP_HARNESSES"] = "BACK_CLIP_HARNESSES";
    OfferSubType["DUAL_CLIP_HARNESSES"] = "DUAL_CLIP_HARNESSES";
    OfferSubType["STEP_IN_HARNESSES"] = "STEP_IN_HARNESSES";
    OfferSubType["SPECIALTY_HARNESSES"] = "SPECIALTY_HARNESSES";
    OfferSubType["SAFETY_HARNESSES"] = "SAFETY_HARNESSES";
    OfferSubType["DAY_PACK_HARNESSES"] = "DAY_PACK_HARNESSES";
    OfferSubType["PATCH_HARNESSES"] = "PATCH_HARNESSES";
    OfferSubType["NO_PULL_HARNESSES"] = "NO_PULL_HARNESSES";
    OfferSubType["ATTACHED_WEARABLES"] = "ATTACHED_WEARABLES";
    OfferSubType["ID_TAGS"] = "ID_TAGS";
    OfferSubType["COLLAR_ID_TAGS"] = "COLLAR_ID_TAGS";
    OfferSubType["TRACKING_TAGS"] = "TRACKING_TAGS";
    OfferSubType["FURNITURE"] = "FURNITURE";
    OfferSubType["BEDS"] = "BEDS";
    OfferSubType["HEATED_BEDS"] = "HEATED_BEDS";
    OfferSubType["PILLOW_BOLSTER_BEDS"] = "PILLOW_BOLSTER_BEDS";
    OfferSubType["ELEVATED_COOLING_BEDS"] = "ELEVATED_COOLING_BEDS";
    OfferSubType["COVERED_BEDS"] = "COVERED_BEDS";
    OfferSubType["STORAGE"] = "STORAGE";
    OfferSubType["CUPBOARDS"] = "CUPBOARDS";
    OfferSubType["TOY_BINS"] = "TOY_BINS";
    OfferSubType["INCLINES"] = "INCLINES";
    OfferSubType["STAIRS"] = "STAIRS";
    OfferSubType["STEPS"] = "STEPS";
    OfferSubType["RAMPS"] = "RAMPS";
    OfferSubType["GROOMING_TABLES"] = "GROOMING_TABLES";
    OfferSubType["BATHS"] = "BATHS";
    OfferSubType["CONTAINMENT"] = "CONTAINMENT";
    OfferSubType["OPEN_CONTAINMENT"] = "OPEN_CONTAINMENT";
    OfferSubType["DOG_HOUSES"] = "DOG_HOUSES";
    OfferSubType["PLAY_PENS"] = "PLAY_PENS";
    OfferSubType["FENCES"] = "FENCES";
    OfferSubType["PHYSICAL_FENCES"] = "PHYSICAL_FENCES";
    OfferSubType["INVISIBLE_FENCES"] = "INVISIBLE_FENCES";
    OfferSubType["FENCE_SYSTEMS"] = "FENCE_SYSTEMS";
    OfferSubType["TIE_OUTS"] = "TIE_OUTS";
    OfferSubType["TIE_OUT_STAKES"] = "TIE_OUT_STAKES";
    OfferSubType["TIE_OUT_CABLES"] = "TIE_OUT_CABLES";
    OfferSubType["GATE_BARRIERS"] = "GATE_BARRIERS";
    OfferSubType["PRESSURE_MOUNTED_GATES"] = "PRESSURE_MOUNTED_GATES";
    OfferSubType["HARD_MOUNTED_GATES"] = "HARD_MOUNTED_GATES";
    OfferSubType["FREE_STANDING_GATES"] = "FREE_STANDING_GATES";
    OfferSubType["CAR_BARRIERS"] = "CAR_BARRIERS";
    OfferSubType["DOORS"] = "DOORS";
    OfferSubType["CLOSED_CONTAINMENT"] = "CLOSED_CONTAINMENT";
    OfferSubType["CRATES"] = "CRATES";
    OfferSubType["WIRED_CRATES"] = "WIRED_CRATES";
    OfferSubType["SOFT_CRATES"] = "SOFT_CRATES";
    OfferSubType["KENNELS"] = "KENNELS";
    OfferSubType["CARRIERS"] = "CARRIERS";
    OfferSubType["STROLLERS"] = "STROLLERS";
    OfferSubType["CONTAINMENT_ACCESSORIES"] = "CONTAINMENT_ACCESSORIES";
    OfferSubType["CRATE_KENNEL_MATS"] = "CRATE_KENNEL_MATS";
    OfferSubType["CRATE_KENNEL_PADS"] = "CRATE_KENNEL_PADS";
    OfferSubType["CONTAINER_PARTS"] = "CONTAINER_PARTS";
    OfferSubType["CONTAINER_COVERS"] = "CONTAINER_COVERS";
    OfferSubType["ENRICHMENT"] = "ENRICHMENT";
    OfferSubType["PHYSICAL_ENRICHMENT"] = "PHYSICAL_ENRICHMENT";
    OfferSubType["FETCH_TOYS"] = "FETCH_TOYS";
    OfferSubType["TOY_BALLS"] = "TOY_BALLS";
    OfferSubType["LAUNCH_TOYS"] = "LAUNCH_TOYS";
    OfferSubType["FETCH_DUMMIES"] = "FETCH_DUMMIES";
    OfferSubType["PLUSH_TOYS"] = "PLUSH_TOYS";
    OfferSubType["CHEW_TOYS"] = "CHEW_TOYS";
    OfferSubType["TUG_TOYS"] = "TUG_TOYS";
    OfferSubType["COGNITIVE_ENRICHMENT"] = "COGNITIVE_ENRICHMENT";
    OfferSubType["INTERACTIVE_TOYS"] = "INTERACTIVE_TOYS";
    OfferSubType["TOY_PUZZLES"] = "TOY_PUZZLES";
    OfferSubType["TRAINING_DUMMIES"] = "TRAINING_DUMMIES";
    OfferSubType["SCENT_TRAINING"] = "SCENT_TRAINING";
    OfferSubType["AGILITY_EQUIPMENT"] = "AGILITY_EQUIPMENT";
    OfferSubType["ENRICHMENT_ACCESSORIES"] = "ENRICHMENT_ACCESSORIES";
    OfferSubType["CLICKERS"] = "CLICKERS";
    OfferSubType["WHISTLES"] = "WHISTLES";
    OfferSubType["CLEANING"] = "CLEANING";
    OfferSubType["BODILY_FLUID_CLEANING"] = "BODILY_FLUID_CLEANING";
    OfferSubType["WASTE_CLEANING"] = "WASTE_CLEANING";
    OfferSubType["WASTE_BAGS"] = "WASTE_BAGS";
    OfferSubType["WASTE_DISPENSERS"] = "WASTE_DISPENSERS";
    OfferSubType["WASTE_SCOOPERS"] = "WASTE_SCOOPERS";
    OfferSubType["POTTY_PADS"] = "POTTY_PADS";
    OfferSubType["POTTY_LITTERS"] = "POTTY_LITTERS";
    OfferSubType["POTTY_TURFS"] = "POTTY_TURFS";
    OfferSubType["MENSTRUAL"] = "MENSTRUAL";
    OfferSubType["POTTY_PAD_HOLDERS"] = "POTTY_PAD_HOLDERS";
    OfferSubType["DIAPERS"] = "DIAPERS";
    OfferSubType["STAIN_REMOVERS"] = "STAIN_REMOVERS";
    OfferSubType["POTTY_TRAINING_AIDS"] = "POTTY_TRAINING_AIDS";
    OfferSubType["POTTY_REPELLENTS"] = "POTTY_REPELLENTS";
    OfferSubType["POTTY_PHEROMONES"] = "POTTY_PHEROMONES";
    OfferSubType["FRESHENERS"] = "FRESHENERS";
    OfferSubType["CANDLES"] = "CANDLES";
    OfferSubType["AIR_FRESHENERS"] = "AIR_FRESHENERS";
    OfferSubType["DEODORIZERS"] = "DEODORIZERS";
    OfferSubType["DEBRIS_CLEANING"] = "DEBRIS_CLEANING";
    OfferSubType["VACUUMS"] = "VACUUMS";
    OfferSubType["STEAM_CLEANERS"] = "STEAM_CLEANERS";
    OfferSubType["LINTERS"] = "LINTERS";
    OfferSubType["PEST_TREATMENTS"] = "PEST_TREATMENTS";
    OfferSubType["INDOOR_PEST_TREATMENTS"] = "INDOOR_PEST_TREATMENTS";
    OfferSubType["FLEA_HOME_SPOT_TREATMENTS"] = "FLEA_HOME_SPOT_TREATMENTS";
    OfferSubType["OUTDOOR_PEST_TREATMENTS"] = "OUTDOOR_PEST_TREATMENTS";
    OfferSubType["FLEA_YARD_SPOT_TREATMENTS"] = "FLEA_YARD_SPOT_TREATMENTS";
})(OfferSubType = exports.OfferSubType || (exports.OfferSubType = {}));
var OldOfferSubType;
(function (OldOfferSubType) {
    OldOfferSubType["UNKNOWN"] = "UNKNOWN";
    // Services
    OldOfferSubType["HEALTH"] = "HEALTH";
    OldOfferSubType["VETERINARIAN"] = "VETERINARIAN";
    OldOfferSubType["VACCINATIONS"] = "VACCINATIONS";
    OldOfferSubType["GENERAL_CHECKUP"] = "GENERAL_CHECKUP";
    OldOfferSubType["EMERGENCY_CARE"] = "EMERGENCY_CARE";
    OldOfferSubType["SURGICAL_CARE"] = "SURGICAL_CARE";
    OldOfferSubType["NUTRITION"] = "NUTRITION";
    OldOfferSubType["PHARMACY_SERVICES"] = "PHARMACY_SERVICES";
    OldOfferSubType["SPECIALIST_CARE"] = "SPECIALIST_CARE";
    OldOfferSubType["SPECIALIST_SKIN_CARE"] = "SPECIALIST_SKIN_CARE";
    OldOfferSubType["SPECIALIST_HAIR_CARE"] = "SPECIALIST_HAIR_CARE";
    OldOfferSubType["SPECIALIST_EYE_CARE"] = "SPECIALIST_EYE_CARE";
    OldOfferSubType["SPECIALIST_DIGESTIVE_CARE"] = "SPECIALIST_DIGESTIVE_CARE";
    OldOfferSubType["SPECIALIST_DENTAL_CARE"] = "SPECIALIST_DENTAL_CARE";
    OldOfferSubType["TRAINING_SERVICES"] = "TRAINING_SERVICES";
    OldOfferSubType["BEHAVIORAL_TRAINING"] = "BEHAVIORAL_TRAINING";
    OldOfferSubType["PUPPY_TRAINING"] = "PUPPY_TRAINING";
    OldOfferSubType["OBEDIENCE_I"] = "OBEDIENCE_I";
    OldOfferSubType["FOUNDATION_SKILLS"] = "FOUNDATION_SKILLS";
    OldOfferSubType["SKILL_BUILDING"] = "SKILL_BUILDING";
    OldOfferSubType["RELIABILITY"] = "RELIABILITY";
    OldOfferSubType["ADVANCED_SKILLS"] = "ADVANCED_SKILLS";
    OldOfferSubType["EXPERT_SKILLS"] = "EXPERT_SKILLS";
    OldOfferSubType["SPORT_TRAINING"] = "SPORT_TRAINING";
    OldOfferSubType["AGILITY_TRAINING"] = "AGILITY_TRAINING";
    OldOfferSubType["HUNTING_TRAINING"] = "HUNTING_TRAINING";
    OldOfferSubType["GUARD_TRAINING"] = "GUARD_TRAINING";
    OldOfferSubType["GROOMING_SERVICES"] = "GROOMING_SERVICES";
    OldOfferSubType["HAIR_GROOMING"] = "HAIR_GROOMING";
    OldOfferSubType["NAIL_GROOMING"] = "NAIL_GROOMING";
    OldOfferSubType["EAR_SPECIALIST"] = "EAR_SPECIALIST";
    OldOfferSubType["SKIN_SPECIALIST"] = "SKIN_SPECIALIST";
    OldOfferSubType["SOCIAL"] = "SOCIAL";
    OldOfferSubType["SOCIAL_SUPPORT"] = "SOCIAL_SUPPORT";
    OldOfferSubType["DOG_WALKERS"] = "DOG_WALKERS";
    OldOfferSubType["DAYCARE"] = "DAYCARE";
    OldOfferSubType["DOG_SITTER"] = "DOG_SITTER";
    OldOfferSubType["BOARDING"] = "BOARDING";
    OldOfferSubType["DROP_IN_VISITS"] = "DROP_IN_VISITS";
    OldOfferSubType["ADOPTION_SERVICES"] = "ADOPTION_SERVICES";
    OldOfferSubType["SOCIAL_RECREATIONAL"] = "SOCIAL_RECREATIONAL";
    OldOfferSubType["DOG_MEET_UP"] = "DOG_MEET_UP";
    OldOfferSubType["DOG_PLAY_GROUPS"] = "DOG_PLAY_GROUPS";
    OldOfferSubType["ADULT_PLAY_GROUPS"] = "ADULT_PLAY_GROUPS";
    OldOfferSubType["PUPPY_PLAY_GROUPS"] = "PUPPY_PLAY_GROUPS";
    OldOfferSubType["RECREATIONAL_DOG_PARKS"] = "RECREATIONAL_DOG_PARKS";
    OldOfferSubType["SMALL_DOG_PARKS"] = "SMALL_DOG_PARKS";
    OldOfferSubType["DOG_PARKS"] = "DOG_PARKS";
    OldOfferSubType["PUPPY_PARKS"] = "PUPPY_PARKS";
    // Products
    OldOfferSubType["FOOD"] = "FOOD";
    OldOfferSubType["MEALS"] = "MEALS";
    OldOfferSubType["CANNED_FOOD"] = "CANNED_FOOD";
    OldOfferSubType["DRY_FOOD"] = "DRY_FOOD";
    OldOfferSubType["RAW_FOOD"] = "RAW_FOOD";
    OldOfferSubType["HUMAN_GRADE"] = "HUMAN_GRADE";
    OldOfferSubType["FROZEN_FOOD"] = "FROZEN_FOOD";
    OldOfferSubType["FREEZE_DRIED"] = "FREEZE_DRIED";
    OldOfferSubType["TREATS"] = "TREATS";
    OldOfferSubType["BISCUITS_BAKERY"] = "BISCUITS_BAKERY";
    OldOfferSubType["BONES_RAWHIDE"] = "BONES_RAWHIDE";
    OldOfferSubType["CHEWY_TREATS"] = "CHEWY_TREATS";
    OldOfferSubType["JERKY"] = "JERKY";
    OldOfferSubType["TRAINING_TREATS"] = "TRAINING_TREATS";
    OldOfferSubType["FREEZE_DRIED_TREATS"] = "FREEZE_DRIED_TREATS";
    OldOfferSubType["DEHYDRATED_TREATS"] = "DEHYDRATED_TREATS";
    OldOfferSubType["PILL_COVERS"] = "PILL_COVERS";
    OldOfferSubType["VETERINARY_DIET"] = "VETERINARY_DIET";
    OldOfferSubType["VETERINARY_MEALS"] = "VETERINARY_MEALS";
    OldOfferSubType["VETERINARY_TREATS"] = "VETERINARY_TREATS";
    OldOfferSubType["MISC"] = "MISC";
    OldOfferSubType["UTENSILS"] = "UTENSILS";
    OldOfferSubType["TOPPINGS"] = "TOPPINGS";
    OldOfferSubType["TOYS"] = "TOYS";
    OldOfferSubType["BALLS"] = "BALLS";
    OldOfferSubType["PLUSH_TOYS"] = "PLUSH_TOYS";
    OldOfferSubType["ROPE_TOYS"] = "ROPE_TOYS";
    OldOfferSubType["FETCH_TOYS"] = "FETCH_TOYS";
    OldOfferSubType["TUG_TOYS"] = "TUG_TOYS";
    OldOfferSubType["INTERACTIVE_TOYS"] = "INTERACTIVE_TOYS";
    OldOfferSubType["CHEW_TOYS"] = "CHEW_TOYS";
    OldOfferSubType["TOY_BINS"] = "TOY_BINS";
    OldOfferSubType["SCRATCHERS"] = "SCRATCHERS";
    OldOfferSubType["WELLNESS"] = "WELLNESS";
    OldOfferSubType["FLEAS_TICKS"] = "FLEAS_TICKS";
    OldOfferSubType["FLEA_COLLARS"] = "FLEA_COLLARS";
    OldOfferSubType["FLEA_ORAL_TREATMENT"] = "FLEA_ORAL_TREATMENT";
    OldOfferSubType["FLEA_SPOT_TREATMENT"] = "FLEA_SPOT_TREATMENT";
    OldOfferSubType["FLEA_SHAMPOO"] = "FLEA_SHAMPOO";
    OldOfferSubType["FLEA_SPRAY_WIPES"] = "FLEA_SPRAY_WIPES";
    OldOfferSubType["FLEA_HOME_YARD_TREATMENT"] = "FLEA_HOME_YARD_TREATMENT";
    OldOfferSubType["FLEA_YARD_TREATMENT"] = "FLEA_YARD_TREATMENT";
    OldOfferSubType["FLEA_HOME_TREATMENT"] = "FLEA_HOME_TREATMENT";
    OldOfferSubType["FLEA_COMB_BRUSHES"] = "FLEA_COMB_BRUSHES";
    OldOfferSubType["PHARMACY"] = "PHARMACY";
    OldOfferSubType["VITAMINS_SUPPLEMENTS"] = "VITAMINS_SUPPLEMENTS";
    OldOfferSubType["EAR_CARE"] = "EAR_CARE";
    OldOfferSubType["EAR_CARE_LIQUIDS"] = "EAR_CARE_LIQUIDS";
    OldOfferSubType["EAR_CARE_CLEANERS"] = "EAR_CARE_CLEANERS";
    OldOfferSubType["EAR_CARE_WIPES"] = "EAR_CARE_WIPES";
    OldOfferSubType["EAR_CARE_GELS_POWDERS"] = "EAR_CARE_GELS_POWDERS";
    OldOfferSubType["EYE_CARE"] = "EYE_CARE";
    OldOfferSubType["EYE_CARE_LIQUIDS"] = "EYE_CARE_LIQUIDS";
    OldOfferSubType["EYE_CARE_CLEANERS"] = "EYE_CARE_CLEANERS";
    OldOfferSubType["EYE_CARE_WIPES"] = "EYE_CARE_WIPES";
    OldOfferSubType["EYE_CARE_GELS_POWDERS"] = "EYE_CARE_GELS_POWDERS";
    OldOfferSubType["DENTAL"] = "DENTAL";
    OldOfferSubType["DENTAL_SUPPLEMENTS"] = "DENTAL_SUPPLEMENTS";
    OldOfferSubType["DENTAL_TREATS"] = "DENTAL_TREATS";
    OldOfferSubType["DENTAL_FRESHENERS_CLEANING"] = "DENTAL_FRESHENERS_CLEANING";
    OldOfferSubType["TOOTH_BRUSHES"] = "TOOTH_BRUSHES";
    OldOfferSubType["TOOTHPASTE_GELS"] = "TOOTHPASTE_GELS";
    OldOfferSubType["DENTAL_SPRAYS_FOAMS_WIPES"] = "DENTAL_SPRAYS_FOAMS_WIPES";
    OldOfferSubType["DIGESTIVE_URINARY"] = "DIGESTIVE_URINARY";
    OldOfferSubType["DIGESTIVE_HEALTH"] = "DIGESTIVE_HEALTH";
    OldOfferSubType["CLEANING_POTTY"] = "CLEANING_POTTY";
    OldOfferSubType["POTTY_PADS_DIAPERS"] = "POTTY_PADS_DIAPERS";
    OldOfferSubType["POTTY_PADS"] = "POTTY_PADS";
    OldOfferSubType["PAD_HOLDERS"] = "PAD_HOLDERS";
    OldOfferSubType["DIAPERS_WRAPS"] = "DIAPERS_WRAPS";
    OldOfferSubType["LITTER_TURF"] = "LITTER_TURF";
    OldOfferSubType["POOP_BAGS_SCOOPERS"] = "POOP_BAGS_SCOOPERS";
    OldOfferSubType["POOP_BAG_DISPENSER"] = "POOP_BAG_DISPENSER";
    OldOfferSubType["POOP_BAG"] = "POOP_BAG";
    OldOfferSubType["POOP_SCOOPERS"] = "POOP_SCOOPERS";
    OldOfferSubType["VACUUMS_STEAM_CLEANERS"] = "VACUUMS_STEAM_CLEANERS";
    OldOfferSubType["STAIN_REMOVERS"] = "STAIN_REMOVERS";
    OldOfferSubType["DEODORIZERS"] = "DEODORIZERS";
    OldOfferSubType["CANDLES"] = "CANDLES";
    OldOfferSubType["AIR_FRESHENERS"] = "AIR_FRESHENERS";
    OldOfferSubType["DEODOR_TREATMENT"] = "DEODOR_TREATMENT";
    OldOfferSubType["LINTERS"] = "LINTERS";
    OldOfferSubType["CONTAINMENT"] = "CONTAINMENT";
    OldOfferSubType["CRATES"] = "CRATES";
    OldOfferSubType["CAR_CRATES"] = "CAR_CRATES";
    OldOfferSubType["CRATE_COVERS_ACCESSORIES"] = "CRATE_COVERS_ACCESSORIES";
    OldOfferSubType["FURNITURE_STYLE_CRATE"] = "FURNITURE_STYLE_CRATE";
    OldOfferSubType["WIRE_CRATES"] = "WIRE_CRATES";
    OldOfferSubType["SOFT_SIDED_CRATES"] = "SOFT_SIDED_CRATES";
    OldOfferSubType["CRATE_MATS_PADS"] = "CRATE_MATS_PADS";
    OldOfferSubType["KENNELS"] = "KENNELS";
    OldOfferSubType["PLAY_PENS"] = "PLAY_PENS";
    OldOfferSubType["PLAY_PEN_ACCESSORIES"] = "PLAY_PEN_ACCESSORIES";
    OldOfferSubType["GATES"] = "GATES";
    OldOfferSubType["PRESSURE_MOUNTED"] = "PRESSURE_MOUNTED";
    OldOfferSubType["HARDWARE_MOUNTED"] = "HARDWARE_MOUNTED";
    OldOfferSubType["FREE_STANDING"] = "FREE_STANDING";
    OldOfferSubType["STEPS_RAMPS"] = "STEPS_RAMPS";
    OldOfferSubType["DOORS"] = "DOORS";
    OldOfferSubType["DOOR_ACCESSORIES"] = "DOOR_ACCESSORIES";
    OldOfferSubType["FENCE_SYSTEMS"] = "FENCE_SYSTEMS";
    OldOfferSubType["DOG_HOUSES"] = "DOG_HOUSES";
    OldOfferSubType["CARRIERS"] = "CARRIERS";
    OldOfferSubType["STROLLERS_BICYCLE_TRAILERS"] = "STROLLERS_BICYCLE_TRAILERS";
    OldOfferSubType["CAR_ACCESSORIES"] = "CAR_ACCESSORIES";
    OldOfferSubType["SEAT_BELTS"] = "SEAT_BELTS";
    OldOfferSubType["BARRIERS"] = "BARRIERS";
    OldOfferSubType["SEAT_COVERS"] = "SEAT_COVERS";
    OldOfferSubType["BEDS_FURNITURE"] = "BEDS_FURNITURE";
    OldOfferSubType["ORTHOPEDIC_BEDS"] = "ORTHOPEDIC_BEDS";
    OldOfferSubType["PILLOW_BEDS"] = "PILLOW_BEDS";
    OldOfferSubType["ELEVATED_COOLING_BEDS"] = "ELEVATED_COOLING_BEDS";
    OldOfferSubType["HEATED_BEDS"] = "HEATED_BEDS";
    OldOfferSubType["COVERED_BEDS"] = "COVERED_BEDS";
    OldOfferSubType["BOLSTER_BEDS"] = "BOLSTER_BEDS";
    OldOfferSubType["SOLD_BEDS"] = "SOLD_BEDS";
    OldOfferSubType["LARGE_BEDS"] = "LARGE_BEDS";
    OldOfferSubType["SOFA_BEDS"] = "SOFA_BEDS";
    OldOfferSubType["BLANKETS_COVERS"] = "BLANKETS_COVERS";
    OldOfferSubType["BOWLS_FEEDER"] = "BOWLS_FEEDER";
    OldOfferSubType["TRAVEL_BOWLS_BAGS"] = "TRAVEL_BOWLS_BAGS";
    OldOfferSubType["BOWLS_DINERS"] = "BOWLS_DINERS";
    OldOfferSubType["BOWLS_DISHES"] = "BOWLS_DISHES";
    OldOfferSubType["ELEVATED_BOWLS"] = "ELEVATED_BOWLS";
    OldOfferSubType["SLOW_FEEDERS"] = "SLOW_FEEDERS";
    OldOfferSubType["FEEDERS_WATERERS"] = "FEEDERS_WATERERS";
    OldOfferSubType["FEEDERS"] = "FEEDERS";
    OldOfferSubType["WATERERS"] = "WATERERS";
    OldOfferSubType["FOUNTAIN_FILTERS"] = "FOUNTAIN_FILTERS";
    OldOfferSubType["WATER_FOUNTAINS"] = "WATER_FOUNTAINS";
    OldOfferSubType["FILTERS_PUMPS"] = "FILTERS_PUMPS";
    OldOfferSubType["PLACEMATS"] = "PLACEMATS";
    OldOfferSubType["STORAGE_ACCESSORIES"] = "STORAGE_ACCESSORIES";
    OldOfferSubType["FOOD_STORAGE"] = "FOOD_STORAGE";
    OldOfferSubType["CAN_COVERS"] = "CAN_COVERS";
    OldOfferSubType["TREAT_JARS"] = "TREAT_JARS";
    OldOfferSubType["FOOD_SCOOPS"] = "FOOD_SCOOPS";
    OldOfferSubType["CLOTHING"] = "CLOTHING";
    OldOfferSubType["SHIRTS"] = "SHIRTS";
    OldOfferSubType["SWEATTER"] = "SHIRTS";
    OldOfferSubType["OUTDOOR_GEAR"] = "OUTDOOR_GEAR";
    OldOfferSubType["WINTER_GEAR"] = "WINTER_GEAR";
    OldOfferSubType["SAFETY_GEAR"] = "SAFETY_GEAR";
    OldOfferSubType["LIFE_JACKETS"] = "LIFE_JACKETS";
    OldOfferSubType["BACKPACKS"] = "BACKPACKS";
    OldOfferSubType["COOLING_VESTS_GEAR"] = "COOLING_VESTS_GEAR";
    OldOfferSubType["INSECT_SUN_PROTECTION"] = "INSECT_SUN_PROTECTION";
    OldOfferSubType["RAIN_GEAR"] = "RAIN_GEAR";
    OldOfferSubType["DRESSES"] = "DRESSES";
    OldOfferSubType["JERSEY_TEAM_ACCESSORIES"] = "JERSEY_TEAM_ACCESSORIES";
    OldOfferSubType["JERSEY_TEAM_COLLARS_LEASHES"] = "JERSEY_TEAM_COLLARS_LEASHES";
    OldOfferSubType["JERSEY_TEAM_JERSEYS"] = "JERSEY_TEAM_JERSEYS";
    OldOfferSubType["PAJAMAS"] = "PAJAMAS";
    OldOfferSubType["BOOTS"] = "BOOTS";
    OldOfferSubType["SOCKS"] = "SOCKS";
    OldOfferSubType["BANDANAS_SCARVES"] = "BANDANAS_SCARVES";
    OldOfferSubType["BOW_TIES"] = "BOW_TIES";
    OldOfferSubType["HATS"] = "HATS";
    OldOfferSubType["COSTUMES"] = "COSTUMES";
    OldOfferSubType["WALKING"] = "WALKING";
    OldOfferSubType["LEASHES"] = "LEASHES";
    OldOfferSubType["LEASH_BASIC"] = "LEASH_BASIC";
    OldOfferSubType["LEASH_RETRACTABLE"] = "LEASH_RETRACTABLE";
    OldOfferSubType["LEASH_HANDS_FREE"] = "LEASH_HANDS_FREE";
    OldOfferSubType["LEASH_DOUBLE_COUPLERS"] = "LEASH_DOUBLE_COUPLERS";
    OldOfferSubType["HARNESSES"] = "HARNESSES";
    OldOfferSubType["HARNESS_BASIC"] = "HARNESS_BASIC";
    OldOfferSubType["HARNESS_SERVICE_DOG"] = "HARNESS_SERVICE_DOG";
    OldOfferSubType["HARNESS_NO_PULL"] = "HARNESS_NO_PULL";
    OldOfferSubType["HARNESS_HANDICAPPED_SUPPORT"] = "HARNESS_HANDICAPPED_SUPPORT";
    OldOfferSubType["HARNESS_FRONT_CLIP"] = "HARNESS_FRONT_CLIP";
    OldOfferSubType["COLLARS"] = "COLLARS";
    OldOfferSubType["COLLARS_PERSONALIZED"] = "COLLARS_PERSONALIZED";
    OldOfferSubType["COLLARS_BASIC"] = "COLLARS_BASIC";
    OldOfferSubType["MUZZLES_HEAD_COLLARS"] = "MUZZLES_HEAD_COLLARS";
    OldOfferSubType["ID_TAGS"] = "ID_TAGS";
    OldOfferSubType["SERVICE_DOG_PATCHES"] = "SERVICE_DOG_PATCHES";
    OldOfferSubType["PERSONALIZED_ID_TAGS"] = "PERSONALIZED_ID_TAGS";
    OldOfferSubType["COLLAR_LIGHTS"] = "COLLAR_LIGHTS";
    OldOfferSubType["COLLAR_CHARMS"] = "COLLAR_CHARMS";
    OldOfferSubType["ID_TAG_ACCESSORIES"] = "ID_TAG_ACCESSORIES";
    OldOfferSubType["LEASH_COLLAR_ACCESSORIES"] = "LEASH_COLLAR_ACCESSORIES";
    OldOfferSubType["TIE_OUTS"] = "TIE_OUTS";
    OldOfferSubType["TIE_OUT_STAKES"] = "TIE_OUT_STAKES";
    OldOfferSubType["TIE_OUT_CABLES"] = "TIE_OUT_CABLES";
    OldOfferSubType["GROOMING"] = "GROOMING";
    OldOfferSubType["GROOMING_TOOLS"] = "GROOMING_TOOLS";
    OldOfferSubType["CLIPPER_BLADES"] = "CLIPPER_BLADES";
    OldOfferSubType["CLIPPER_BLADES_PARTS"] = "CLIPPER_BLADES_PARTS";
    OldOfferSubType["HAIR_CLIPPER_SHEARS"] = "HAIR_CLIPPER_SHEARS";
    OldOfferSubType["GROOMING_TABLES"] = "GROOMING_TABLES";
    OldOfferSubType["GROOMING_APPAREL_EXTRAS"] = "GROOMING_APPAREL_EXTRAS";
    OldOfferSubType["SHAMPOOS_CONDITIONERS"] = "SHAMPOOS_CONDITIONERS";
    OldOfferSubType["SHAMPOOS"] = "SHAMPOOS";
    OldOfferSubType["CONDITIONERS"] = "CONDITIONERS";
    OldOfferSubType["BRUSHES_COMBS"] = "BRUSHES_COMBS";
    OldOfferSubType["SKIN_CARE_SKIN_CARE"] = "SKIN_CARE_SKIN_CARE";
    OldOfferSubType["SKIN_CARE_SUN_SCREEN"] = "SKIN_CARE_SUN_SCREEN";
    OldOfferSubType["SKIN_CARE_MOISTURIZER"] = "SKIN_CARE_MOISTURIZER";
    OldOfferSubType["SKIN_CARE_HOT_SPOT_ITCH_RELIEF"] = "SKIN_CARE_HOT_SPOT_ITCH_RELIEF";
    OldOfferSubType["SKIN_CARE_BALM"] = "SKIN_CARE_BALM";
    OldOfferSubType["SKIN_CARE_WIPES"] = "SKIN_CARE_WIPES";
    OldOfferSubType["PAW_NAIL_CARE"] = "PAW_NAIL_CARE";
    OldOfferSubType["PAW_CARE"] = "PAW_CARE";
    OldOfferSubType["NAIL_CLIPPERS"] = "NAIL_CLIPPERS";
    OldOfferSubType["NAIL_GRINDERS_ACCESSORIES"] = "NAIL_GRINDERS_ACCESSORIES";
    OldOfferSubType["NAIL_POLISH_CAPS"] = "NAIL_POLISH_CAPS";
    OldOfferSubType["WATERLESS_GROOMING"] = "WATERLESS_GROOMING";
    OldOfferSubType["WATERLESS_BATH"] = "WATERLESS_BATH";
    OldOfferSubType["DEODORIZING_SPRAYS_COLOGNES"] = "DEODORIZING_SPRAYS_COLOGNES";
    OldOfferSubType["GROOMING_SPRAYS_DETANGLERS"] = "GROOMING_SPRAYS_DETANGLERS";
    OldOfferSubType["BATH_SHOWER_SUPPLIES"] = "BATH_SHOWER_SUPPLIES";
    OldOfferSubType["BATH_TOWELS"] = "BATH_TOWELS";
    OldOfferSubType["DRYERS"] = "DRYERS";
    OldOfferSubType["BATHTUB_SHOWER_HOSE_ACCESSORIES"] = "BATHTUB_SHOWER_HOSE_ACCESSORIES";
    OldOfferSubType["BATH_MATS"] = "BATH_MATS";
    OldOfferSubType["TRAINING"] = "TRAINING";
    OldOfferSubType["CALMING_AIDS"] = "CALMING_AIDS";
    OldOfferSubType["TRAVEL_AIDS"] = "TRAVEL_AIDS";
    OldOfferSubType["TRAINING_LEASHES_COLLARS"] = "TRAINING_LEASHES_COLLARS";
    OldOfferSubType["BARK_CONTROLLING_REMOTE_TRAINING"] = "BARK_CONTROLLING_REMOTE_TRAINING";
    OldOfferSubType["BARK_CONTROLLING_REMOTE_TRAINING_COLLARS"] = "BARK_CONTROLLING_REMOTE_TRAINING_COLLARS";
    OldOfferSubType["BARK_CONTROLLING_REMOTE_TRAINING_SYSTEMS"] = "BARK_CONTROLLING_REMOTE_TRAINING_SYSTEMS";
    OldOfferSubType["BARK_CONTROLLING_REMOTE_TRAINING_CHARGER_ACCESSORIES"] = "BARK_CONTROLLING_REMOTE_TRAINING_CHARGER_ACCESSORIES";
    OldOfferSubType["BARK_CONTROLLING_REMOTE_TRAINING_BATTERIES"] = "BARK_CONTROLLING_REMOTE_TRAINING_BATTERIES";
    OldOfferSubType["REPELLENTS"] = "REPELLENTS";
    OldOfferSubType["POTTY_TRAINING_AIDS"] = "POTTY_TRAINING_AIDS";
    OldOfferSubType["AGILITY_TRAINING_EQUIPMENT"] = "AGILITY_TRAINING_EQUIPMENT";
    OldOfferSubType["SPORT_EQUIPMENT"] = "SPORT_EQUIPMENT";
    OldOfferSubType["SPORT_TRAINING_LEASHES"] = "SPORT_TRAINING_LEASHES";
    OldOfferSubType["WHISTLE_EQUIPMENT"] = "WHISTLE_EQUIPMENT";
    OldOfferSubType["DUMMIES"] = "DUMMIES";
    OldOfferSubType["CLICKER_EQUIPMENT"] = "CLICKER_EQUIPMENT";
    OldOfferSubType["DUMMY_LAUNCHER_SYSTEM"] = "DUMMY_LAUNCHER_SYSTEM";
})(OldOfferSubType = exports.OldOfferSubType || (exports.OldOfferSubType = {}));
